var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9107 28.2726C15.5858 28.2726 16.2332 28.0044 16.7106 27.527C17.188 27.0496 17.4561 26.4022 17.4561 25.7271C17.4561 25.052 17.188 24.4046 16.7106 23.9272C16.2332 23.4498 15.5858 23.1816 14.9107 23.1816C14.2356 23.1816 13.5881 23.4498 13.1108 23.9272C12.6334 24.4046 12.3652 25.052 12.3652 25.7271C12.3652 26.4022 12.6334 27.0496 13.1108 27.527C13.5881 28.0044 14.2356 28.2726 14.9107 28.2726V28.2726ZM27.638 28.2726C28.3131 28.2726 28.9605 28.0044 29.4379 27.527C29.9152 27.0496 30.1834 26.4022 30.1834 25.7271C30.1834 25.052 29.9152 24.4046 29.4379 23.9272C28.9605 23.4498 28.3131 23.1816 27.638 23.1816C26.9629 23.1816 26.3154 23.4498 25.8381 23.9272C25.3607 24.4046 25.0925 25.052 25.0925 25.7271C25.0925 26.4022 25.3607 27.0496 25.8381 27.527C26.3154 28.0044 26.9629 28.2726 27.638 28.2726V28.2726Z",
    stroke: "#9D9D9D",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5182 25.7275H23.8182V12.4912C23.8182 12.2886 23.7377 12.0944 23.5945 11.9512C23.4513 11.808 23.2571 11.7275 23.0545 11.7275H6M11.9182 25.7275H9.30909C9.20881 25.7275 9.10951 25.7078 9.01686 25.6694C8.92421 25.631 8.84003 25.5748 8.76912 25.5039C8.69821 25.433 8.64196 25.3488 8.60358 25.2561C8.56521 25.1635 8.54545 25.0642 8.54545 24.9639V18.7275",
    stroke: "#9D9D9D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27344 15.5459H12.3643",
    stroke: "#9D9D9D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8164 15.5459H30.9564C31.104 15.5459 31.2484 15.5887 31.3722 15.6692C31.496 15.7496 31.5938 15.8641 31.6539 15.999L33.932 21.1255C33.9754 21.2229 33.998 21.3282 33.9982 21.4348V24.9641C33.9982 25.0644 33.9785 25.1637 33.9401 25.2563C33.9017 25.349 33.8455 25.4331 33.7746 25.5041C33.7037 25.575 33.6195 25.6312 33.5268 25.6696C33.4342 25.708 33.3349 25.7277 33.2346 25.7277H30.8164M23.8164 25.7277H25.0891",
    stroke: "#9D9D9D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourier);
export default __webpack_public_path__ + "static/media/Courier.44b6eb44fb2d77c4f08b7c1c548712e8.svg";
export { ForwardRef as ReactComponent };